/**
 * The ONE date-time format of the storage surfaces (UI/UX fix round A, review U11): the grid's locale date-time with
 * seconds for display, the exact UTC instant for the tooltip. The storage grid, the properties panels, the queue grid,
 * the SAS result and dialogs, the snapshot dialog and the Transfers drawer all format through it, so one value never
 * shows in two formats side by side. An unparsable value is shown as it came.
 */
export function formatStorageDateTime(value: string | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
}

/** "2026-09-26 07:28:51 UTC" (milliseconds kept when present) — the exact instant, for a tooltip. */
export function storageDateTimeUtc(value: string | Date | null | undefined): string | undefined {
  if (value === null || value === undefined || value === '') return undefined;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  const iso = date.toISOString();
  const trimmed = iso.endsWith('.000Z') ? iso.slice(0, 19) : iso.slice(0, 23);
  return `${trimmed.replace('T', ' ')} UTC`;
}

/** A duration in seconds as people say it ("7 days", "1 hour 30 minutes", "45 seconds"; U21). */
export function formatStorageDuration(totalSeconds: number): string {
  if (!Number.isFinite(totalSeconds)) return '';
  if (totalSeconds < 0) return 'never expires';
  const units: Array<[number, string]> = [[86_400, 'day'], [3_600, 'hour'], [60, 'minute'], [1, 'second']];
  const parts: string[] = [];
  let rest = Math.floor(totalSeconds);
  for (const [size, name] of units) {
    const count = Math.floor(rest / size);
    rest -= count * size;
    if (count > 0 && parts.length < 2) parts.push(`${count} ${name}${count === 1 ? '' : 's'}`);
  }
  return parts.length > 0 ? parts.join(' ') : '0 seconds';
}
